import moment from "moment";

export function getDateSubtitle(startDate: string, endDate: string) {
  if (!endDate) {
    return `A partir de ${moment(startDate).format("MMM/YYYY")}`
  }
  
  return `De ${moment(startDate).format("MMM/YYYY")} até ${moment(
    endDate
  ).format("MMM/YYYY")}`;
}
